import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setCiteGeneratorPaperData, toggleModal } from 'store/ui/actions'
import PropTypes from 'prop-types'
import Header from 'components/typography/Header'
import Authors from 'components/misc/Authors'
import Link from 'components/misc/Link'
import Reference from 'components/report/Reference'
import Notification from '../misc/Notification'
import SharingWidget from 'components/misc/SharingWidget'

import styles from './styles/TitlePaper.css'
import ProcessMath from '../misc/ProcessMath'

const TRUNCATE_AT = 516
const truncateString = (str, n) => (str.length > n) ? str.substr(0, n - 1) + '&hellip;' : str

export const Abstract = ({
  abstract,
  truncateAt = TRUNCATE_AT
}) => {
  const [expandAbstract, setExpandAbstract] = useState(true)
  return (
    <div className={styles.abstractWrapper}>
      <ProcessMath>
        <Header className={styles.abstract} level={2}>
          <strong>Abstract:</strong> {' '} <span dangerouslySetInnerHTML={{ __html: expandAbstract ? truncateString(abstract, truncateAt) : abstract }} />

          {abstract?.length >= TRUNCATE_AT && (
            <span className={styles.expandAbstract} onClick={() => setExpandAbstract(!expandAbstract)} role='button' tabIndex={0}>
              {' '} {expandAbstract ? 'Show more' : 'Hide'}
            </span>
          )}
        </Header>
      </ProcessMath>
    </div>
  )
}

const Title = ({ paper }) => {
  if (!paper || !paper.title) {
    return null
  }

  if (!paper.doi) {
    return (
      <Header level={1} className={styles.paperTitleHeader} dangerouslySetInnerHTML={{ __html: paper.title }} />
    )
  }

  return (
    <Header level={1} className={styles.paperTitleHeader} dangerouslySetInnerHTML={{ __html: paper.title }} />
  )
}

export const TitlePaper = ({ paper, refCheck = false }) => {
  const dispatch = useDispatch()
  const handleGenerateCitation = () => {
    dispatch(setCiteGeneratorPaperData({
      citeGeneratorPaperData: paper
    }))
    dispatch(toggleModal('generateCitation'))
  }

  return (
    <div className={styles.titlePaper}>
      <Reference {...paper} handleGenerateCitation={handleGenerateCitation} showDOI showSciteReport={refCheck} journalAsBadge />
      {paper?.doi && !refCheck &&
        <div className={styles.widgetContainer}>
          <div className={styles.delimiter}>|</div>
          <Notification
            source={paper?.doi}
            name={paper?.title || 'untitled'}
            category='paper'
            className={styles.notification}
          />
          <span> |</span>
          <SharingWidget type={paper?.doi ? 'Report' : 'Reference Check'} title={paper?.title || 'untitled'} />
        </div>}

      <div className={styles.paperTitle}>
        <ProcessMath>
          <Title paper={paper} />
        </ProcessMath>
      </div>
      {paper?.authors && <Authors authors={paper?.authors} />}
      {paper?.abstract && <Abstract abstract={paper?.abstract} />}

      {!refCheck && (<Link className={styles.helpMeCta} onClick={() => dispatch(toggleModal('whatIsThisReport'))} blue underline>Help me understand this report</Link>)}
    </div>
  )
}

TitlePaper.propTypes = {
  paper: PropTypes.shape({
    title: PropTypes.string.isRequired,

    doi: PropTypes.string,
    authors: PropTypes.array,
    slug: PropTypes.string,
    year: PropTypes.number,
    shortJournal: PropTypes.string,
    issue: PropTypes.string,
    page: PropTypes.string,
    pmPublicationType: PropTypes.string,
    issns: PropTypes.arrayOf(
      PropTypes.string
    ),

    // NOTE: These come from the journal table
    journal: PropTypes.string,
    journalSlug: PropTypes.string,
    refCheck: PropTypes.bool
  })
}

export default TitlePaper
